export enum ClientErrorSource {
  Unknown = 0,
  Portal = 1,
  AppWebView = 2,
  AppShell = 3,
}
